import script from "./JobsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./JobsPanel.vue?vue&type=style&index=0&id=11de524f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11de524f"]])

export default __exports__